import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import axios from "axios";

function UpdateCompany() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [registerDate, setRegisterDate] = useState("");
  const [companyCode, setCompanyCode] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyPhone, setCompanyPhone] = useState("");
  const [companyMobilePhone, setCompanyMobilePhone] = useState("");
  const [quotationMsaDate, setQuotationMsaDate] = useState("");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openUpdateSuccess, setOpenUpdateSuccess] = useState(false);
  const [openUpdateFail, setOpenUpdateFail] = useState(false);
  const [salesList, setSalesList] = useState([]);
  const [selectedSales, setSelectedSales] = useState("");
  const [values, setValues] = useState({
    quotationPriceUsd: "",
    quotationPriceIdr: "",
    salesOrderPriceUsd: "",
    salesOrderPriceIdr: "",
  });
  const [displayValues, setDisplayValues] = useState({
    quotationPriceUsd: "",
    quotationPriceIdr: "",
    salesOrderPriceUsd: "",
    salesOrderPriceIdr: "",
  });

  const resource = "update-company";

  function formatNominal(nominal) {
    if (nominal.charAt(nominal.length - 1) == ",") {
      nominal = nominal.slice(0, -1) + ",0";
    }

    // Konversi ke string untuk pengecekan desimal
    let strNominal = nominal.toString();

    // Pisahkan bagian desimal jika ada
    let [integerPart, decimalPart] = strNominal.split(",");

    // Format bagian integer secara manual
    let formattedInteger = "";
    let counter = 0;
    for (let i = integerPart.length - 1; i >= 0; i--) {
      formattedInteger = integerPart[i] + formattedInteger;
      counter++;
      if (counter % 3 === 0 && i !== 0) {
        formattedInteger = "." + formattedInteger;
      }
    }

    // Gabungkan kembali dengan bagian desimal jika ada
    let result = decimalPart
      ? formattedInteger + "," + decimalPart
      : formattedInteger;

    if (result.includes(",0")) {
      result = result.replace(",0", ",");
    }
    return result;
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("id-ID", {
      // Pastikan ada 9 digit desimal
      maximumFractionDigits: 9, // Jangan bulatkan lebih dari 7 digit desimal
    }).format(value);
  };

  const handleCurrencyChange = (key) => (e) => {
    let rawValue = e.target.value.replace(/[^0-9,]/g, "");
    if (rawValue.includes(",")) {
      setDisplayValues((prev) => ({ ...prev, [key]: formatNominal(rawValue) }));
      setValues((prev) => ({
        ...prev,
        [key]: parseFloat(rawValue.replace(",", ".")),
      }));
    } else {
      const numericValue = parseInt(rawValue, 10) || "";
      if (rawValue === "0") {
        setDisplayValues((prev) => ({ ...prev, [key]: rawValue }));
        setValues((prev) => ({ ...prev, [key]: rawValue }));
      } else {
        setDisplayValues((prev) => ({
          ...prev,
          [key]: numericValue ? formatCurrency(numericValue) : "",
        }));
        setValues((prev) => ({ ...prev, [key]: numericValue }));
      }
    }
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("token");

    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();
  }, []);

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  useEffect(() => {
    getCompanyDetail(searchParams.get("companyId"));
  }, []);

  const getCompanyDetail = async (companyId) => {
    try {
      const response = await fetch(
        `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/company/company-detail?companyId=${companyId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();

      const data = result[0];
      if (!response.ok) {
        setError(data.message || "Failed to fetch session token data");
        throw new Error(data.message || "Failed to fetch session token data");
      }

      setRegisterDate(formatDate(data.register_date));
      setCompanyCode(data.company_code);
      setCompanyName(data.company_name);
      setCompanyAddress(data.company_address);
      setCompanyPhone(data.company_phone);
      setCompanyMobilePhone(data.company_mobile_phone);
      setSelectedSales(data.company_sales_pic);

      if (data.quotation_msa_date) {
        // Konversi dari "2024-07-23T00:00:00.000Z" ke "2024-07-23"
        const formattedDate = data.quotation_msa_date.split("T")[0];
        setQuotationMsaDate(formattedDate);
      }

      setValues((prev) => ({
        ...prev,
        quotationPriceUsd: data.quotation_price_usd,
        quotationPriceIdr: data.quotation_price_idr,
        salesOrderPriceUsd: data.sales_order_price_usd,
        salesOrderPriceIdr: data.sales_order_price_idr,
      }));

      // Pastikan UI juga menampilkan nilai dengan format yang sesuai
      setDisplayValues((prev) => ({
        ...prev,
        quotationPriceUsd:
          data.quotation_price_usd !== null
            ? formatCurrency(data.quotation_price_usd)
            : "",
        quotationPriceIdr:
          data.quotation_price_idr !== null
            ? formatCurrency(data.quotation_price_idr)
            : "",
        salesOrderPriceUsd:
          data.sales_order_price_usd !== null
            ? formatCurrency(data.sales_order_price_usd)
            : "",
        salesOrderPriceIdr:
          data.sales_order_price_idr !== null
            ? formatCurrency(data.sales_order_price_idr)
            : "",
      }));

      // setQuotationMsaDate(formatDate(data.quotation_msa_date));
    } catch (error) {
      console.error("Error get company detail:", error.message);
      setError("Error get company detail: " + error.message);
    }
  };

  const formatDate = (datetime) => {
    const date = new Date(datetime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = {
      companyId: searchParams.get("companyId"),
      companyName: companyName,
      companyAddress: companyAddress,
      companyPhone: companyPhone,
      companyMobilePhone: companyMobilePhone,
      companySalesPic: selectedSales,
      quotationMsaDate: quotationMsaDate,
    };

    const combinedData = {
      ...formData,
      ...values,
    };

    try {
      const response = await fetch(
        "https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/company/update-company",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(combinedData),
        }
      );

      const data = await response.json();
      const responseBody = JSON.parse(data.body);
      if (!response.ok) {
        setError(data.message || "Failed to submit form");
        throw new Error(data.message || "Failed to submit form");
      }

      const { message } = responseBody;
      if (message == "success") {
        setOpenConfirm(false);
        setOpenUpdateSuccess(true);
      } else {
        setOpenConfirm(false);
        setOpenUpdateFail(true);
      }
    } catch (error) {
      console.error("Submission Error:", error.message);
      setError("Submission Error: " + error.message);
    }
  };

  const handleClose = () => {
    setOpenConfirm(false);
    setOpenUpdateFail(false);
  };

  const handleConfirmation = async (event) => {
    event.preventDefault();
    setOpenConfirm(true);
  };

  function updateSuccess() {
    navigate("/company-list");
  }

  useEffect(() => {
    loadSalesList();
  }, []);

  const loadSalesList = async () => {
    //Role Sales
    const roleId = 2;
    const result = await axios.get(
      `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/master/internal/find-by-role?roleId=${roleId}`
    );
    const data = result.data;
    setSalesList(data);
  };

  const handleSalesListChange = (event) => {
    setSelectedSales(event.target.value);
  };

  return (
    <div className="container-order-input">
      <Dialog open={openConfirm}>
        <DialogTitle>
          {"Are you sure you want to update this company?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Clicking "Yes" will update this company.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            No
          </Button>
          <Button onClick={handleSubmit} color="primary" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openUpdateSuccess}>
        <DialogTitle>{"Update company submitted successfully"}</DialogTitle>
        <DialogActions>
          <Button onClick={updateSuccess} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openUpdateFail}>
        <DialogTitle>{"Update company submitted Failed"}</DialogTitle>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <h1>Cross Connect Update Company</h1>
      <form onSubmit={handleConfirmation}>
        <div className="order-information-order-input">
          <div className="title-order-input">
            {error && <p className="error-message">{error}</p>}
          </div>
        </div>
        <div className="box-two-part">
          <div className="requestor-information">
            <div className="textbox-gray">
              <label htmlFor="registerDate">Register Date</label>
              <input
                text="date"
                placeholder={registerDate}
                disabled
                style={{ paddingLeft: "5px" }}
              />
            </div>
            <div className="textbox">
              <label htmlFor="companyName">Company Name</label>
              <input
                type="text"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                style={{ paddingLeft: "5px" }}
              />
            </div>
            <div className="textbox-gray">
              <label htmlFor="companyCode">Company Code</label>
              <input
                type="text"
                placeholder={companyCode}
                disabled
                style={{ paddingLeft: "5px" }}
              />
            </div>
            <div className="textbox">
              <label htmlFor="companyAddress">Company Address</label>
              <textarea
                value={companyAddress}
                onChange={(e) => setCompanyAddress(e.target.value)}
                style={{
                  backgroundColor: "white",
                  color: "black",
                  paddingLeft: "5px",
                }}
              ></textarea>
            </div>
            <div className="textbox">
              <label htmlFor="companyPhone">Company Phone</label>
              <input
                type="tel"
                id="companyPhone"
                name="companyPhone"
                value={companyPhone}
                pattern="0\d{6,}"
                onChange={(e) => setCompanyPhone(e.target.value)}
                style={{ paddingLeft: "5px" }}
              />
            </div>
            <div className="textbox">
              <label htmlFor="companyMobilePhone">Company Mobile Phone</label>
              <input
                type="tel"
                id="companyMobilePhone"
                name="companyMobilePhone"
                value={companyMobilePhone}
                pattern="08\d{8,}"
                onChange={(e) => setCompanyMobilePhone(e.target.value)}
                style={{ paddingLeft: "5px" }}
              />
            </div>
            <div className="textbox">
              <label htmlFor="comboBox">Company Sales PIC</label>
              <select
                id="comboBox"
                name="options"
                value={selectedSales}
                onChange={handleSalesListChange}
                required
              >
                <option value="" disabled>
                  Select Company Sales PIC
                </option>
                {salesList.map((item) => (
                  <option
                    key={item.xcp_internal_id}
                    value={item.xcp_internal_id}
                  >
                    {item.xcp_internal_name}
                  </option>
                ))}
              </select>
            </div>
            <>
              {[
                { key: "salesOrderPriceUsd", label: "Sales Order Price (USD)" },
                { key: "salesOrderPriceIdr", label: "Sales Order Price (IDR)" },
                { key: "quotationPriceUsd", label: "Quotation Price (USD)" },
                { key: "quotationPriceIdr", label: "Quotation Price (IDR)" },
              ].map(({ key, label }) => (
                <div className="textbox" key={key}>
                  <label htmlFor={key}>{label}</label>
                  <input
                    type="text"
                    value={displayValues[key] || ""}
                    onChange={handleCurrencyChange(key)}
                    required
                    style={{ textAlign: "right", paddingRight: "5px" }}
                  />
                </div>
              ))}
            </>
            <div className="textbox">
              <label htmlFor="quotationMsaDate">Quotation MSA Date</label>
              <input
                type="date"
                id="quotationMsaDate"
                value={quotationMsaDate}
                onChange={(e) => setQuotationMsaDate(e.target.value)}
                required
                style={{ paddingLeft: "5px" }}
              />
            </div>
          </div>
        </div>
        <input
          type="submit"
          className="btn-submit-order-input"
          value="Update"
        />
      </form>
    </div>
  );
}

export default UpdateCompany;
